import { concatMap, map, withLatestFrom } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { saleActions } from './sale.actions'
import { saleSelectors } from './sale.selectors'
import { SaleDocumentService } from './sale-document.service'

@Injectable()
export class SaleRelationEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private saleDocumentService: SaleDocumentService
  ) {}

  public createOneDocumentLink = createEffect(() =>
    this.actions$.pipe(
      ofType(saleActions.createOneDocumentLink),
      concatMap((action) =>
        this.saleDocumentService
          .createOne(action.saleId, action.documentId)
          .pipe(
            withLatestFrom(
              this.store.select(saleSelectors.selectById, action.saleId)
            ),
            map(([response, sale]) =>
              saleActions.upsertOne({
                entity: {
                  ...sale,
                  documents: [...(sale.documents ?? []), action.documentId]
                }
              })
            )
          )
      )
    )
  )
  public deleteOneDocumentLink = createEffect(() =>
    this.actions$.pipe(
      ofType(saleActions.deleteOneDocumentLink),
      concatMap((action) =>
        this.saleDocumentService
          .deleteOne(action.saleId, action.documentId)
          .pipe(
            withLatestFrom(
              this.store.select(saleSelectors.selectById, action.saleId)
            ),
            map(([response, sale]) =>
              saleActions.upsertOne({
                entity: {
                  ...sale,
                  documents: sale.documents?.length
                    ? [
                        ...sale.documents.filter(
                          (documentId) => documentId !== action.documentId
                        )
                      ]
                    : []
                }
              })
            )
          )
      )
    )
  )
}
